"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./RichTextViewer.css");
var sanitize = require("sanitize-html");
var RichTextViewer = /** @class */ (function (_super) {
    __extends(RichTextViewer, _super);
    function RichTextViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.createMarkup = _this.createMarkup.bind(_this);
        return _this;
    }
    RichTextViewer.prototype.componentDidMount = function () {
        this.props.allowScripts && this.appendScriptToBody(this.props.html);
    };
    RichTextViewer.prototype.appendScriptToBody = function (html) {
        var scriptElement = /<script\b[^>]*>([\s\S]*?)<\/script>/gm;
        var scriptOpeningTag = /<script\b[^>]*([\s\S]*?)>/gm;
        var match;
        var _loop_1 = function () {
            var script = document.createElement('script');
            var scriptAttrs = (scriptOpeningTag.exec(match[0]) || [])[0];
            scriptAttrs && scriptAttrs.split(' ').forEach(function (a) {
                var _a = a.split('='), attribute = _a[0], value = _a[1];
                if (attribute && value) {
                    script[attribute] = value.split('"')[1];
                }
            });
            script.innerHTML = match[1];
            document.body.appendChild(script);
        };
        while (match = scriptElement.exec(html)) {
            _loop_1();
        }
    };
    RichTextViewer.prototype.createMarkup = function () {
        var _filter = {};
        _filter['allowedTags'] = this.props.allowedTags;
        _filter['allowedAttributes'] = this.props.allowedAttributes;
        _filter['allowedClasses'] = this.props.allowedClasses;
        return { __html: sanitize(this.props.html || '', _filter) };
    };
    RichTextViewer.prototype.render = function () {
        return (React.createElement("div", { className: "p-htmlviewer", role: this.props.role, "data-tag": this.props.tag, dangerouslySetInnerHTML: this.createMarkup(), "aria-label": this.props.ariaLabel || undefined, tabIndex: this.props.ariaLabel ? -1 : undefined }));
    };
    RichTextViewer.defaultProps = {
        tag: '',
        html: '',
        allowedTags: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'a', 'ul', 'ol',
            'li', 'b', 'u', 'i', 'strong', 'em', 'strike', 'hr', 'br', 'div', 'span',
            'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'sup', 'sub'],
        allowedAttributes: {
            'a': ['href', 'name', 'target', 'class'],
            'img': ['src', 'alt']
        },
        role: 'document',
        ariaLabel: '',
        allowedClasses: {
            'a': ['fancy', 'simple'],
            'h1': ['large']
        },
        allowScripts: false
    };
    return RichTextViewer;
}(React.Component));
exports.default = RichTextViewer;
//# sourceMappingURL=RichTextViewer.js.map


//////////////////
// WEBPACK FOOTER
// ../player-rich-text-viewer/build/control/RichTextViewer.js
// module id = 17
// module chunks = 0 2